// extracted by mini-css-extract-plugin
export var section = "index-module--section--go-q3";
export var image = "index-module--image--OGjw7";
export var texts = "index-module--texts--u7gfZ";